import WizardTip from '../../components/WizardTip';
import WizardTipCard from '../../components/WizardTipCard';
import { VIEW_TYPE } from '../../components/WizardTip/constants';

import {
  StyledWizardTipCardContainer,
  StyledWizardTipCardContainerDesktop,
  StyledWizardTipCardContainerMobile,
} from '../../components/Wizard/PageWizard/StyledComponents';

type Props = {
  header: string;
  showDesktopViewBreakpoint: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  isPremiumTip?: boolean;
};

const WizardTipCardContainer = ({ header, showDesktopViewBreakpoint, children, icon = null, isPremiumTip }: Props) => {
  return (
    <aside aria-labelledby="tip-title">
      <StyledWizardTipCardContainer showDesktopViewBreakpoint={showDesktopViewBreakpoint}>
        <StyledWizardTipCardContainerMobile showDesktopViewBreakpoint={showDesktopViewBreakpoint}>
          {isPremiumTip ? (
            <WizardTip viewType={VIEW_TYPE.CARD}>
              <WizardTipCard header={header} isPremiumTip={isPremiumTip}>
                {children}
              </WizardTipCard>
            </WizardTip>
          ) : (
            <WizardTip header={header} viewType={VIEW_TYPE.ACCORDION}>
              {children}
            </WizardTip>
          )}
        </StyledWizardTipCardContainerMobile>

        <StyledWizardTipCardContainerDesktop showDesktopViewBreakpoint={showDesktopViewBreakpoint}>
          <WizardTip viewType={VIEW_TYPE.CARD}>
            {icon ? (
              <WizardTipCard header={header} icon={icon}>
                {children}
              </WizardTipCard>
            ) : (
              <WizardTipCard header={header} isPremiumTip={isPremiumTip}>
                {children}
              </WizardTipCard>
            )}
          </WizardTip>
        </StyledWizardTipCardContainerDesktop>
      </StyledWizardTipCardContainer>
    </aside>
  );
};

export default WizardTipCardContainer;
